/**
 * CargaDestinatario
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {Endereco} from '@/model/resource/Endereco'
import {CargaDestinatarioCollection} from '@/model/collection/CargaDestinatarioCollection'

/* TODO: review generated class */
export class CargaDestinatario extends Resource {
  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(Endereco)
  endereco: Endereco | null = null

  /**
   * Pode ser razão social
   */
  nome: string | null = null

  cpfCnpj: string | null = null
  telefone: string | null = null

  indicadorIe: string | null = null
  inscricaoEstadual: string | null = null
  inscricaoSuframa: string | null = null
  im: string | null = null
  email: string | null = null

  get $id() {
    /* TODO: define the ID */
    return 0
  }
  set $id(val) {
    /* TODO: define the ID */
  }
  get $tag() {
    return String(this.nome)
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  get idEnderecoFk() {
    if (!this.endereco) return 0
    return this.endereco.$id
  }
  set idEnderecoFk(val) {
    if (!this.endereco) this.endereco = new Endereco()
    this.endereco.$id = val
  }

  /**
   * Gets a instance of a given ID of CargaDestinatario
   */
  async getCargaDestinatario(id: number) {
    return await Request.get(`/admin/carga-destinatario/${id}`)
      .name('getCargaDestinatario')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of CargaDestinatario
   */
  static async listCargaDestinatario(params: any) {
    return await Request.get(`/admin/carga-destinatario`, {params})
      .name('listCargaDestinatario')
      .as(CargaDestinatarioCollection)
      .getData()
  }

  /**
   * Persists a new instance of CargaDestinatario. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCargaDestinatario() {
    return await Request.post(`/admin/carga-destinatario`, this)
      .name('persistCargaDestinatario')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CargaDestinatario to use it in a CSV file
   */
  static async listCsvCargaDestinatario(params: any) {
    return await Request.get(`/admin/carga-destinatario/csv`, {params})
      .name('listCsvCargaDestinatario')
      .as(CargaDestinatarioCollection)
      .getData()
  }
}
